import { css, html } from 'react-strict-dom';
import { Style } from 'src/constants';
import { color } from 'src/constants/color.css';

type Props = {
  selected?: boolean;
  disabled?: boolean;
};

export default function RadioButton({ selected, disabled }: Props) {
  return (
    <html.div
      style={[
        Style.row,
        Style.centerBoth,
        styles.radio,
        selected && styles.radioSelected,
        disabled && styles.radioDisabled,
        selected && disabled && styles.radioSelectedDisabled,
      ]}
    >
      {selected && (
        <html.div
          style={[styles.radioDot, disabled && styles.radioDotDisabled]}
        />
      )}
    </html.div>
  );
}

const styles = css.create({
  radio: {
    width: 20,
    height: 20,
    borderRadius: '50%',
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: color.neutral40,
    backgroundColor: '#fff',
  },
  radioSelected: {
    borderWidth: 0,
    backgroundColor: color.accent,
  },
  radioDisabled: {
    borderColor: color.neutral20,
    backgroundColor: color.neutral5,
  },
  radioSelectedDisabled: {
    borderWidth: 0,
    backgroundColor: color.neutral20,
  },
  radioDot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: color.neutral0,
  },
  radioDotDisabled: {
    backgroundColor: color.neutral5,
  },
});
